module.exports = __webpack_public_path__ + "static/media/logo.45d34df4.png";